// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import FastClick from "fastclick";
import VueRouter from "vue-router";
import App from "./App";
import "lib-flexible/flexible.js"; //移动端屏幕适配
// import Home from './components/HelloWorld'
import router from "./router/index.js";
import store from "@/store/index.js";
import axios from "axios";
import VueAxios from "vue-axios";
import { post, fetch, patch, put } from "./utils/http";
import changeBottom from "@/directive/changeBottom.js";
// import keepTowNum from '@/filter/keepTowNum.js'
// import {GET_HOME_URL} from '@/constants/index.js'
import "@/assets/js/uiScript.js";
import "@/assets/js/GeoUtils.js";
import "@/assets/js/isheng.js";
import jsonp from "jsonp";
//引入 Vant
import Vant from 'vant';
// import 'vant/lib/vant-css/index.css';
import "vant/lib/index.css";
import $ from "jquery";
import "signalr";
import '../src/assets/style/common.less';
Vue.use(Vant);
Vue.use(VueAxios, axios, VueRouter);
// Vue.use(VueRouter)
Vue.directive("changeBottom", changeBottom);
// Vue.filter('keepTowNum',keepTowNum)
FastClick.attach(document.body);
Vue.config.ignoredElements = ["wx-open-launch-weapp"];
Vue.config.productionTip = false;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app-box");

Vue.prototype.$jsonp = jsonp;
Vue.prototype.$post = post;
Vue.prototype.$fetch = fetch;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;

//设置标题
document.title = "长沙不动产登记";
//返回目标元素在数组中的索引值
Array.prototype.indexOf = function(el) {
  for (var i = 0, n = this.length; i < n; i++) {
    if (this[i] === el) {
      return i;
    }
  }
  return -1;
};
Array.prototype.swap = function(index1, index2) {
  if (index1 < index2 && index1 == this.length - 1) {
    return;
  } else if (index1 > index2 && index1 == 0) {
    return;
  }
  this[index1] = this.splice(index2, 1, this[index1])[0];
  return this;
};



// WEBPACK FOOTER //
// ./src/main.js